/** Áreas / departamentos estándar para solicitudes de compra. */
export const PURCHASE_REQUEST_AREAS = [
  'Producción',
  'Mantención',
  'Calidad',
  'Comercial',
  'Logística',
  'Administración',
  'I+D',
  'Finanzas',
];

export const purchaseRequestAreaOptions = (extra = []) => {
  const seen = new Set();
  const list = [];
  [...PURCHASE_REQUEST_AREAS, ...extra].forEach((raw) => {
    const name = String(raw || '').trim();
    if (!name) return;
    const key = name.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    list.push(name);
  });
  return list.map((name) => ({ value: name, label: name }));
};

export const normalizeDepartment = (value) => String(value || '').trim();
